import InlineEditAutocomplete from './InlineEditAutocomplete';

export default InlineEditAutocomplete;
